import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { Frac } from '~lmo/models/frac.model';
import { LmoFracsService } from '~lmo/services';

@Component({
  selector: 'sa-lmo-auto-procurement-dialog',
  templateUrl: './lmo-auto-procurement-dialog.component.html',
})
export class LmoAutoProcurementDialogComponent implements OnInit {
  public currentFrac$: Observable<Frac>;

  constructor(
    public dialogRef: MatDialogRef<LmoAutoProcurementDialogComponent>,
    private fracService: LmoFracsService,
    private snackBar: MatSnackBar,
  ) {}

  public ngOnInit() {
    this.currentFrac$ = this.fracService.currentFrac$;
  }

  public cancelAction() {
    this.dialogRef.close(false);
  }

  public updateStatus(autoPurchaseOrderAssignment: boolean) {
    this.fracService.toggleAutoPurchaseOrderAssignment$(autoPurchaseOrderAssignment).subscribe((success) => {
      if (success) {
        this.snackBar.open(`Well has been updated!`, null, { duration: 5000 });
      }
      this.dialogRef.close();
    });
  }
}
